<template>
  <div v-if="validURL" class="container" id="forgot-password-page">
    <h1 class="page-title">{{ $t("form.reset_password.title") }}</h1>
    <hr>
    <div class="row">
      <div class="col-12 col-md-6 offset-md-3 text-center form-forgot-password">
        <form @submit.prevent="submitForm" class="p-t-15" role="form" novalidate="novalidate">
          <div class="form-group form-group-default text-left">
            <label>{{ $t("SignInForm.password") }}</label>
            <div class="controls">
              <input v-model="password" v-validate="'required|min:8'" type="password" class="form-control"
                name="password" required="" id="password" aria-required="true">
            </div>
          </div>
          <transition name="slide-fade">
            <label v-show="errors.has('password')" id="password-error" class="error text-left" for="password">
              {{ errors.first('password') }}
            </label>
          </transition>

          <div class="form-group form-group-default text-left">
            <label>{{ $t("form.reset_password.password_confirmation") }}</label>
            <div class="controls">
              <input v-validate="'required|min:8|confirmed:password'"  type="password" class="form-control"
                name="password_confirmation" required="" aria-required="true">
            </div>
          </div>
          <transition name="slide-fade">
            <label v-show="errors.has('password_confirmation')" id="password-error" class="error text-left" for="password">
              {{ errors.first('password_confirmation') }}
            </label>
          </transition>
          <button class="btn btn-danger btn-block m-t-15 p-t-15 p-b-15" type="submit"
            :disabled="errors.items.length > 0 || password.length == 0">
            {{ $t("buttons.change_password") }}
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
  import { mapGetters } from 'vuex'
  import { userStatus } from '@/settings/users'

  export default {
    data: function() {
      return ({
        password: '',
        validURL: false,
        message: null
      })
    },
    computed: {
      ...mapGetters({
        currentUser: 'auth/currentUser'
      }),
      reset_password_token() {
        return this.$route.query.token
      },
      email() {
        return this.$route.query.email
      }
    },
    mounted: function() {
      var self = this
      this.$store.dispatch('recoverPassword/validateUrl',
        { email: this.email, reset_password_token: this.reset_password_token })
      .then(response => {
        self.validURL = response.validURL
        if(self.validURL.first_password_changed_at && self.validURL.state == "pending"){
          self.$router.push({ name: 'updateInformation' })
        }
      })
    },
    methods: {
      submitForm() {
        var self = this

        this.$validator.validateAll()
        .then(function(response) {
          if(response){
            self.updateNewPassword()
          }
        })
      },
      updateNewPassword: async function() {
        var messageResetFailed = { content: this.$i18n.t('messages.password_update_failed'), type: 'danger' }

        try {
          var params = { email: this.email, password: this.password, reset_password_token: this.reset_password_token }
          var response = await this.$store.dispatch('recoverPassword/resetPassword', params)

          if(response['resetPasswordSuccess']) {
            if (this.currentUser.state == userStatus.pending) {
              this.message = null
              this.$router.push({ name: 'updateInformation' })
            } else {
              this.$router.push("/")
              this.message = {type: 'success', content: this.$i18n.t('messages.password_updated')}
            }
          } else {
            this.message = messageResetFailed
          }
        } catch (error) {
          this.message = messageResetFailed
        } finally {
          if(this.message) {
            this.$store.dispatch('message/enable', this.message)
          }
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/recoverPassword/ResetPasswordForm.vue